import { gql } from '@apollo/client';

export default gql`
query GetAnimo($IdAnimo: ID!) {
  Animo(IdAnimo: $IdAnimo) {
    IdAnimo
    Animo
  }
}
`;